import { render, staticRenderFns } from "./CadastroFederalInput.vue?vue&type=template&id=78d307fd&"
import script from "./CadastroFederalInput.vue?vue&type=script&lang=js&"
export * from "./CadastroFederalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports